import { defineStyle, defineStyleConfig } from '@chakra-ui/styled-system';
import { keyframes } from '@emotion/react';

export { keyframes } from '@emotion/react';

const animation = keyframes`
  from { transform: translate3d(-100%, 0, 0); }
  to { transform: translate3d(100%, 0, 0); }
`;

const afterStyle = (foregroundColor: string) => ({
  animation: `${animation} infinite 1.5s`,
  backgroundColor: foregroundColor,
  content: '""',
  height: '100%',
  left: 0,
  maskImage:
    'linear-gradient(to left, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.63) 35%, rgb(0, 0, 0) 48%, rgba(0, 0, 0, 0.57) 55%, rgba(0, 0, 0, 0) 100%)',
  pointerEvents: 'none',
  position: 'absolute',
  top: 0,
  width: '100%',
});

const baseStyle = defineStyle(({ foregroundColor, isActive }) => {
  return {
    _after: isActive ? afterStyle(foregroundColor) : {},
    overflow: 'hidden',
    position: 'relative',
  };
});

const SkeletonTheme = defineStyleConfig({
  baseStyle,
});

export default SkeletonTheme;
